module.exports = __webpack_public_path__ + "img/to.19b07d17.svg";